import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "./assets/x_math_logo.png";

const Navbar = () => {
  const { pathname } = useLocation();
  const isMarketing = pathname === "/" || pathname === "/about" || pathname === "/inside";
  const linkClass = (path) =>
    `text-sm font-medium transition-colors duration-200 ${
      pathname === path ? "text-sky-300" : "text-gray-300 hover:text-white"
    }`;

  return (
    <nav
      className={`${
        isMarketing
          ? "fixed inset-x-0 top-0 bg-gray-900/70"
          : "sticky top-0 bg-gradient-to-r from-gray-900 to-gray-800"
      } backdrop-blur-md text-white z-50 border-b border-white/5`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="relative flex items-center justify-between gap-3 py-3 sm:py-4">
          <Link to="/" className="flex items-center shrink-0 relative z-10">
            <img
              src={logo}
              alt="X-Maths"
              className="h-9 sm:h-11 w-auto brightness-0 invert"
            />
          </Link>

          <div className="hidden sm:flex absolute inset-x-0 justify-center pointer-events-none">
            <div className="flex items-center gap-6 pointer-events-auto">
              <Link to="/" className={linkClass("/")}>
                Home
              </Link>
              <Link to="/about" className={linkClass("/about")}>
                About
              </Link>
              <Link to="/inside" className={linkClass("/inside")}>
                Inside
              </Link>
            </div>
          </div>

          <div className="flex items-center gap-2 sm:gap-4 relative z-10">
            <Link
              to="/login"
              className="inline-flex px-3 sm:px-4 py-1.5 sm:py-2 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 transition-all duration-300 text-sm"
            >
              Login
            </Link>
            <Link
              to="/signup"
              className="px-3 sm:px-5 py-1.5 sm:py-2 rounded-full bg-gradient-to-r from-blue-600 to-sky-600 hover:from-blue-500 hover:to-sky-500 transition-all duration-300 shadow-lg hover:shadow-blue-500/30 text-sm font-medium"
            >
              Sign Up
            </Link>
          </div>
        </div>

        <div className="flex sm:hidden items-center justify-center gap-5 pb-3">
          <Link to="/" className={linkClass("/")}>
            Home
          </Link>
          <Link to="/about" className={linkClass("/about")}>
            About
          </Link>
          <Link to="/inside" className={linkClass("/inside")}>
            Inside
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
